/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListModelStateSwitch = {
  model: string
  created_by: string
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  before_state: ListModelStateSwitch.before_state
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  after_state: ListModelStateSwitch.after_state
  readonly created_at: string
}
export namespace ListModelStateSwitch {
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  export enum before_state {
    LIVE = "live",
    CHALLENGER = "challenger",
    DISABLED = "disabled",
    PENDING_ACTION = "pending-action",
  }
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  export enum after_state {
    LIVE = "live",
    CHALLENGER = "challenger",
    DISABLED = "disabled",
    PENDING_ACTION = "pending-action",
  }
}
